import { styled } from '@mui/material';

import { theme } from 'styles';

export const PageW = styled('div')`
  padding-left: 38px;
  margin-top: 88px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1023px) {
    padding: 0px 16px;
    padding-bottom: 96px;
  }
`;

export const TitleW = styled('div')`
  display: flex;
  align-items: center;
  svg {
    width: 36px;
    height: 36px;
  }
`;

export const TitleText = styled('div')`
  font-size: 18px;
  line-height: 30px;
  margin-left: 16px;

  @media (max-width: 1023px) {
    line-height: 24px;
    font-weight: 500;
  }
`;

export const CardW = styled('div')`
  background: #ffffff;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  padding: 20px 16px 16px;
  cursor: pointer;
  &:hover {
    background: ${theme.palette.info.light};
  }
`;

export const CardsW = styled('div')`
  display: grid;
  border-radius: 8px;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  row-gap: 16px;

  @media (max-width: 1023px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
